// @ts-check
import { ModuleProcessMappings } from '@erpagroapp/common';
import {
  ConfigurationParameterReturnType,
  ConfigurationParameterSource,
} from '../enums';
import { defineConfig, defineDefaultProps } from '../helpers';

const defaultProps = defineDefaultProps(/** @type {const} */ ({
  loadingRules: {
    requiredModuleIds: [
      ModuleProcessMappings.Commercialisation.Id,
    ],
    requiredProcessIds: [
      ModuleProcessMappings.Commercialisation.Processes.Expeditions.Id,
    ],
  },
}));

export function expeditions() {
  return defineConfig({
    EliminarReservaAnteriorExpediciones: {
      source: ConfigurationParameterSource.ERP,
      component: 'Comercializacion',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: true,
      ...defaultProps,
    },
    LecturaContinuaCargasExpediciones: {
      source: ConfigurationParameterSource.ERP,
      component: 'Comercializacion',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    IntroduccionManualCBLecturaPalesExpeciones: {
      source: ConfigurationParameterSource.ERP,
      component: 'Comercializacion',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    PermitirMoverPalesReservadosEnOrdenCarga: {
      source: ConfigurationParameterSource.ERP,
      component: 'Comercializacion',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    PermitirGenerarOrdenesCargaSinPedidoEnMovilidad: {
      source: ConfigurationParameterSource.ERP,
      component: 'Comercializacion',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    PaisTipoExpedicionNacional: {
      source: ConfigurationParameterSource.ERP,
      component: 'Comercializacion',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
    EliminarReservaClientesInternosExpediciones: {
      source: ConfigurationParameterSource.ERP,
      component: 'Comercializacion',
      returnType: ConfigurationParameterReturnType.NUMBER,
      defaultValue: null,
      ...defaultProps,
    },
  });
}
